// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import VueCookies from 'vue-cookies'
import JsonExcel from 'vue-json-excel'


import PNotify from 'pnotify/dist/es/PNotify';
import PNotifyConfirm from 'pnotify/dist/es/PNotifyConfirm';
import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js';
PNotify.defaults.styling = 'material';
window.PNotify = PNotify;
window.PNotifyConfirm = PNotifyConfirm;

import GetpolisConstants from "./plugins/GetpolisConstants";
import MultiFiltersPlugin from './plugins/MultiFilters'
import Clipboard from 'v-clipboard'

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Helpers
//import colors from 'vuetify/es5/util/colors'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue');

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueMask from 'v-mask'
import Vue from 'vue'
Vue.use(VueMask, {
    placeholders: {
        V: /[0-9ABCDEFGHJKLMNPRSTUVWXYZ\*]/i,
        G: /[АВЕКМНОРСТУХ_\*]/i,
        Q: /[0-9_\*]/i,
        N: /[\dABCDEFGHIJKLMNPQRSTUVWXYZ-]/i,
        S: /[АБВГДЕЖЗИКЛМНОПРСТУФХЦЧШЩЭЮЯ]/i,
        P: /[0-9\*]/i
    }
})

// Sentry.init({
//     dsn: 'https://4558ccdc83614c5bb9bb1532b315c502@sentry.io/1843302',
//     integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
// });

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Vuetify, {
    theme: {
        primary: '#00ba57',
        secondary: '#00ba57',
        accent: '#00ba57'
    },
    iconfont: 'md'
});

Vue.use(VueCookies);
VueCookies.config('30d');

Vue.use(GetpolisConstants);
Vue.use(MultiFiltersPlugin);
Vue.use(Clipboard);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.component('home-page', require('./components/pages/Homepage.vue'));
Vue.component('b2b-landing-page', require('./components/pages/B2bLanding.vue'));
Vue.component('osago-faq-page', require('./components/pages/OsagoFaq.vue'));
Vue.component('agent-faq-page', require('./components/pages/AgentFaq.vue'));
Vue.component('osago-contacts-page', require('./components/pages/OsagoContacts.vue'));
Vue.component('osago-company-page', require('./components/pages/OsagoCompany.vue'));
Vue.component('api-soft', require('./components/pages/ApiSoft.vue'));
Vue.component('api-soft-promo', require('./components/pages/ApiSoftPromo.vue'));
Vue.component('homepage-feedback', require('./components/elements/Feedback.vue'));
Vue.component('form-out-popup', require('./components/elements/FormOutPopup.vue'));
Vue.component('osago-calc-form', require('./components/elements/CalcForm.vue'));
Vue.component('info-carousel', require('./components/elements/InfoCarousel.vue'));
Vue.component('home-questions', require('./components/elements/Questions.vue'));
Vue.component('header-component', require('./components/elements/HeaderComponent.vue'));
Vue.component('bitrix-form', require('./components/elements/BitrixForm.vue'));
Vue.component('promo-header-component', require('./components/elements/PromoHeaderComponent.vue'));

Vue.component('services-page', require('./components/ServicesPage.vue'));
Vue.component('services-list', require('./components/services/ServicesList.vue'));
Vue.component('services-underlist', require('./components/services/ServicesUnderList.vue'));
Vue.component('services-carousel', require('./components/services/ServicesCarousel.vue'));
Vue.component('service-dcard-page', require('./components/services/ServiceDcardPage.vue'));
Vue.component('service-gibdd-page', require('./components/services/ServiceGibddPage.vue'));
Vue.component('service-kbm-page', require('./components/services/ServiceKbmPage.vue'));
Vue.component('service-sales-contract-page', require('./components/services/ServiceSalesContractPage.vue'));
Vue.component('services-request-form', require('./components/services/ServicesRequestForm.vue'));
Vue.component('services-notification-form', require('./components/services/ServicesNotificationForm.vue'));
Vue.component('services-kbm-request-form', require('./components/services/ServicesKbmRequestForm.vue'));
Vue.component('service-person-form', require('./components/services/ServicePersonForm.vue'));
Vue.component('service-transport-form', require('./components/services/ServiceTransportForm.vue'));
Vue.component('services-kbm-result', require('./components/services/ServicesKbmResult.vue'));
Vue.component('file-upload-field', require('./components/elements/FileUploadField.vue'));
Vue.component('file-upload', require('./components/elements/FileUpload.vue'));
Vue.component('files-upload', require('./components/elements/FilesUpload.vue'));
Vue.component('kbm-links', require('./components/elements/KbmLinks.vue'));
Vue.component('policy-dialog-custom', require('./components/elements/PolicyDialogCustom.vue'));

Vue.component('companies-list', require('./components/CompaniesList.vue'));
Vue.component('osago-long-form', require('./components/OsagoLongForm.vue'));
Vue.component('osago-insurance-conditions', require('./components/elements/OsagoInsuranceConditions.vue'));
Vue.component('osago-partners', require('./components/elements/Partners.vue'));
Vue.component('osago-preloader', require('./components/elements/Preloader.vue'));
Vue.component('osago-prolongation-form', require('./components/OsagoProlongationForm.vue'));
Vue.component('osago-pre-calc-form-steps', require('./components/OsagoPreCalcFormWithSteps.vue'));
Vue.component('osago-companies-list-cross', require('./components/elements/OsagoCompaniesListCross.vue'));
Vue.component('osago-date', require('./components/fields/Date.vue'));
Vue.component('osago-month', require('./components/fields/Month.vue'));
Vue.component('osago-name', require('./components/fields/Name.vue'));
Vue.component('osago-gender', require('./components/fields/Gender.vue'));
Vue.component('osago-transport', require('./components/fields/Transport.vue'));
Vue.component('osago-cardoc', require('./components/fields/CarDoc.vue'));
Vue.component('osago-todoc', require('./components/fields/ToDoc.vue'));
Vue.component('osago-user', require('./components/fields/User.vue'));
Vue.component('osago-address-dadata', require('./components/fields/AddressDadata.vue'));
Vue.component('osago-city-dadata', require('./components/fields/CityDadata.vue'));
Vue.component('osago-area-dadata-autocomplete', require('./components/fields/AreaDadataAutocomplete.vue'));
Vue.component('osago-district-dadata-autocomplete', require('./components/fields/DistrictDadataAutocomplete.vue'));
Vue.component('osago-house-dadata', require('./components/fields/HouseDadata.vue'));
Vue.component('osago-preview', require('./components/fields/Preview.vue'));
Vue.component('dashboard-sort', require('./components/DashboardSort.vue'));
Vue.component('sms-login', require('./components/SmsLogin.vue'));
Vue.component('dashboard-admin', require('./components/b2b/DashboardAdmin.vue'));
Vue.component('dashboard-agent', require('./components/b2b/DashboardAgent.vue'));
Vue.component('dashboard-operator', require('./components/b2b/DashboardOperator.vue'));

// b2b
Vue.component('b2b-registration', require('./components/b2b/RegisterAgent.vue'));
Vue.component('b2b-registration-operator', require('./components/b2b/RegisterOperator.vue'));
Vue.component('b2b-login', require('./components/b2b/Login.vue'));
Vue.component('b2b-login-verify', require('./components/b2b/LoginVerify.vue'));
Vue.component('b2b-pass-recovery', require('./components/b2b/PasswordRecovery.vue'));
Vue.component('b2b-pass-reset', require('./components/b2b/PasswordReset.vue'));
Vue.component('b2b-profile', require('./components/b2b/Profile.vue'));
Vue.component('b2b-agents-list', require('./components/b2b/AgentsList.vue'));
Vue.component('b2b-policy-list', require('./components/b2b/PolicyList.vue'));
Vue.component('b2b-policy-list-old', require('./components/b2b/PolicyListOld.vue'));
Vue.component('b2b-commissions', require('./components/b2b/Commissions.vue'));
Vue.component('b2b-commissions-table', require('./components/b2b/CommissionsTable.vue'));
Vue.component('b2b-commissions-crosses', require('./components/b2b/CommissionsCrosses.vue'));
Vue.component('b2b-commissions-antimite', require('./components/b2b/CommissionsAntimite.vue'));
Vue.component('b2b-commissions-banking-products', require('./components/b2b/CommissionsBankingProducts.vue'));
Vue.component('b2b-commissions-transit', require('./components/b2b/CommissionsTransit.vue'));
Vue.component('b2b-commission-template', require('./components/b2b/CommissionTemplate.vue'));
Vue.component('downloadExcel', JsonExcel);
Vue.component('b2b-segmentations', require('./components/b2b/Segmentations.vue'));
Vue.component('b2b-segmentation-template', require('./components/b2b/SegmentationsTemplate.vue'));
Vue.component('b2b-manage-link', require('./components/b2b/ManageLink.vue'));
Vue.component('b2b-manage-cross-link', require('./components/ManageCrossLink.vue'));
Vue.component('b2b-accounting-list', require('./components/b2b/AccountingList.vue'));
Vue.component('b2b-services', require('./components/b2b/Services.vue'));

//blog
Vue.component('blog-page', require('./components/blog/Blog.vue'));
Vue.component('article-page', require('./components/blog/Article.vue'));
Vue.component('faq-page', require('./components/blog/Faq.vue'));

//news
Vue.component('news-page', require('./components/pages/NewsPage.vue'));
Vue.component('news-article-page', require('./components/pages/NewsArticlePage.vue'));

// kbm
Vue.component('kbm-check-and-recovery', require('./components/kbm/KbmCheckAndRecovery.vue'));
Vue.component('kbm-recovery-list', require('./components/kbm/KbmRecoveryList.vue'));
Vue.component('kbm-free-recoveries', require('./components/kbm/FreeRecoveriesInfo.vue'));

// egarant companies
Vue.component('b2b-egarant-companies', require('./components/egarant-companies/EgarantCompaniesList.vue'));
Vue.component('b2b-egarant-company-settings', require('./components/egarant-companies/EgarantCompanySettings.vue'));

// issuance policies
Vue.component('b2b-issuance-policies', require('./components/issuance-policies/IssuancePolicies.vue'));
Vue.component('b2b-policy-confirm', require('./components/PolicyConfirm.vue'));

// mortgage
Vue.component('mortgage-long-form', require('./components/mortgage/MortgageLongForm.vue'));
Vue.component('mortgage-precalc-form', require('./components/mortgage/MortgagePrecalcForm.vue'));
Vue.component('mortgage-precalc-info', require('./components/mortgage/MortgagePrecalcInfo.vue'));
Vue.component('mortgage-calc-info', require('./components/mortgage/MortgageCalcInfo.vue'));
Vue.component('mortgage-preview', require('./components/mortgage/MortgagePreviewForm.vue'));

Vue.component('result-component', require('./components/ResultComponent.vue'));

Vue.component('info-soft', require('./components/InfoSoft.vue'));
Vue.component('cancel-contract', require('./components/CancelContract.vue'));
Vue.component('anti-mite', require('./components/AntiMite.vue'));
Vue.component('anti-mite-list', require('./components/AntiMiteList.vue'));
Vue.component('site-guide', require('./components/site-guide/SiteGuide.vue'));

// bank-products
Vue.component('dashboard-bank-products', require('./components/bank-products/DashboardBankProducts.vue'));
Vue.component('b2b-bank-products-list', require('./components/bank-products/BankProductsList.vue'));
Vue.component('banking-offers-form', require('./components/bank-products/banking-offers/BankingOffersForm.vue'));
Vue.component('banking-offers-list', require('./components/bank-products/banking-offers/BankingOffersList.vue'));
Vue.component('banking-offer-preview', require('./components/bank-products/banking-offers/BankingOfferPreview.vue'));

Vue.component('banking-products-load-file', require('./components/bank-products/BankingProductsLoadFile.vue'));

Vue.component('banking-products-load-file-form', require('./components/bank-products/BankingProductsLoadFile.vue'));


Vue.component('banking-products-settings', require('./components/bank-products/BankingProductsSettings.vue'));


Vue.component('transit-osago', require('./components/transit-osago/TransitOsago.vue'));
Vue.component('transit-transport', require('./components/transit-osago/TransitTransport.vue'));
Vue.component('transit-list', require('./components/transit-osago/TransitList.vue'));

Vue.component('change', require('./components/change/ChangeContainer.vue'));

const app = new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/js/app.js